import {
  AndroidBlockEntity,
  AnimalBlockEntity,
  BasicBlockEntity,
  BlockEntity,
  CageBlockEntity,
  CandleBlockEntity,
  ChainBlockEntity,
  ChameleonBlockEntity,
  CoffinBlockEntity,
  DogBlockEntity,
  DoorBlockEntity,
  FireboxBlockEntity,
  FuguBlockEntity,
  HatBlockEntity,
  HazardBlockEntity,
  ThickIceBlockEntity,
  FullIceBlockEntity,
  HalfIceBlockEntity,
  KappaBlockEntity,
  KettleBlockEntity,
  LockBlockEntity,
  MiniFuguBlockEntity,
  PantherBlockEntity,
  PipeBlockEntity,
  NestBlockEntity,
  SirenBlockEntity,
  SkullBlockEntity,
  SlimeBlockEntity,
  SpiderBlockEntity,
  StatueBlockEntity,
  ThrowerBlockEntity,
  VirusBlockEntity,
  WallBlockEntity,
  IceBlockEntity,
  ZombieBlockEntity,
  WormBlockEntity,
  CocoonBlockEntity,
  ButterflyBlockEntity,
  CurtainBlockEntity,
  ShellBlockEntity,
  PondBlockEntity,
  CandyBagBlockEntity,
  CandyBlockEntity,
  SodaBlockEntity,
  MushroomBlockEntity,
  ChocolateEggBlockEntity,
  AlarmBlockEntity,
  BubblesBlockEntity,
  ParcelsBlockEntity,
  FossilBlockEntity,
  CornBlockEntity,
  PopcornBlockEntity,
  TunaCanBlockEntity,
  TunaFishBlockEntity,
  RainbowBubbleBlockEntity,
  CoolerBlockEntity,
  TvBlockEntity,
  ShieldBubbleBlockEntity,
  BathtubBlockEntity,
  BombBlockEntity,
  FirecrackerBoxBlockEntity,
} from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { AndroidCollision } from './AndroidCollision';
import { AnimalCollision } from './AnimalCollision';
import { BasicCollision } from './BasicCollision';
import { BombCollision } from './BombCollision';
import { ButterflyCollision } from './ButterflyCollision';
import { CageCollision } from './CageCollision';
import { CandleCollision } from './CandleCollision';
import { CandyBagCollision } from './CandyBagCollision';
import { CandyCollision } from './CandyCollision';
import { ChainCollision } from './ChainCollision';
import { ChameleonCollision } from './ChameleonCollision';
import { CocoonCollision } from './CocoonCollision';
import { CoffinCollision } from './CoffinCollision';
import { CubeCollision } from './CubeCollision';
import { CurtainCollision } from './CurtainCollision';
import { PondCollision } from './PondCollision';
import { DogCollision } from './DogCollision';
import { DoorCollision } from './DoorCollision';
import { FireboxCollision } from './FireboxCollision';
import { FuguCollision } from './FuguCollision';
import { FullIceCollision } from './FullIceCollision';
import { HalfIceCollision } from './HalfIceCollision';
import { HatCollision } from './HatCollision';
import { HazardCollision } from './HazardCollision';
import { IceCollision } from './IceCollision';
import { ICollision } from './ICollision';
import { KappaCollision } from './KappaCollision';
import { KettleCollision } from './KettleCollision';
import { LockCollision } from './LockCollision';
import { MiniFuguCollision } from './MiniFuguCollision';
import { PantherCollision } from './PantherCollision';
import { PipeCollision } from './PipeCollision';
import { NestCollision } from './NestCollision';
import { RocketCollision } from './RocketCollision';
import { ShellCollision } from './ShellCollision';
import { SirenCollision } from './SirenCollision';
import { SkullCollision } from './SkullCollision';
import { SlimeCollision } from './SlimeCollision';
import { SpiderCollision } from './SpiderCollision';
import { StatueCollision } from './StatueCollision';
import { ThickIceCollision } from './ThickIceCollision';
import { ThrowerCollision } from './ThrowerCollision';
import { VirusCollision } from './VirusCollision';
import { WallCollision } from './WallCollision';
import { WormCollision } from './WormCollision';
import { ZombieCollision } from './ZombieCollision';
import { SodaCollision } from './SodaCollision';
import { MushroomCollision } from './MushroomCollision';
import { ChocolateEggCollision } from './ChocolateEggCollision';
import { AlarmCollision } from './AlarmCollision';
import { BubblesCollision } from './BubblesCollision';
import { ParcelsCollision } from './ParcelsCollision';
import { FossilCollision } from './FossilCollision';
import { CornCollision } from './CornCollision';
import { PopcornCollision } from './PopcornCollision';
import { TunaCanCollision } from './TunaCanCollision';
import { TunaFishCollision } from './TunaFishCollision';
import { RainbowBubbleCollision } from './RainbowBubbleCollision';
import { FirecrackerBoxCollision } from './FirecrackerBoxCollision';
import { CoolerCollision } from './CoolerCollision';
import { TvCollision } from './TvCollision';
import { ShieldBubbleCollision } from './ShieldBubbleCollision';
import { BathtubCollision } from './BathtubCollision';
import { SharpenerBlockEntity } from '../../blocks/sharpener/SharpenerBlockEntity';
import { SharpenerBlockCollision } from '../../blocks/sharpener/SharpenerBlockCollision';
import { BarrelBlockCollision } from '../../blocks/barrel/BarrelBlockCollision';
import { BarrelBlockEntity } from '../../blocks/barrel/BarrelBlockEntity';
import { RainbowSoapBlockCollision } from '../../blocks/rainbowSoap/RainbowSoapBlockCollision';
import { RainbowSoapBlockEntity } from '../../blocks/rainbowSoap/RainbowSoapBlockEntity';
import { BigEggBlockEntity } from '../../blocks/bigEgg/BigEggBlockEntity';
import { BigEggBlockCollision } from '../../blocks/bigEgg/BigEggBlockCollision';
import { PiggyBankBlockCollision } from '../../blocks/piggyBank/PiggyBankBlockCollision';
import { PiggyBankBlockEntity } from '../../blocks/piggyBank/PiggyBankBlockEntity';
import { BalloonBoxBlockCollision } from '../../blocks/balloonBox/BalloonBoxBlockCollision';
import { BalloonBoxBlockEntity } from '../../blocks/balloonBox/BalloonBoxBlockEntity';
import { OctopusBlockCollision } from '../../blocks/octopus/OctopusBlockCollision';
import { OctopusBlockEntity } from '../../blocks/octopus/OctopusBlockEntity';
import { FlowerFidgetBlockCollision } from '../../blocks/flowerFidget/FlowerFidgetBlockCollision';
import { FlowerFidgetBlockEntity } from '../../blocks/flowerFidget/FlowerFidgetBlockEntity';
import { GrassBlockCollision } from '../../blocks/grass/GrassBlockCollision';
import { GrassBlockEntity } from '../../blocks/grass/GrassBlockEntity';
import { MagicBunniesBlockCollision } from '../../blocks/magicBunnies/MagicBunniesBlockCollision';
import { MagicBunniesBlockEntity } from '../../blocks/magicBunnies/MagicBunniesBlockEntity';
import { LaserBoxBlockCollision } from '../../blocks/laserBox/LaserBoxBlockCollision';
import { LaserBoxBlockEntity } from '../../blocks/laserBox/LaserBoxBlockEntity';

// api
//-----------------------------------------------------------------------------
export function createCollision(
  scene: GameScene,
  entity: BlockEntity,
): ICollision | undefined {
  // create collision from entity's colliding state
  switch (entity.c.block.props.type) {
    case 'android':
      return new AndroidCollision(scene, entity as AndroidBlockEntity);
    case 'animal':
      return new AnimalCollision(scene, entity as AnimalBlockEntity);
    case 'basic':
      return new BasicCollision(scene, entity as BasicBlockEntity);
    case 'bomb':
      return new BombCollision(scene, entity as BombBlockEntity);
    case 'cage':
      return new CageCollision(scene, entity as CageBlockEntity);
    case 'candle':
      return new CandleCollision(scene, entity as CandleBlockEntity);
    case 'chain':
      return new ChainCollision(scene, entity as ChainBlockEntity);
    case 'chameleon':
      return new ChameleonCollision(scene, entity as ChameleonBlockEntity);
    case 'coffin':
      return new CoffinCollision(scene, entity as CoffinBlockEntity);
    case 'cube':
      return new CubeCollision(scene, entity);
    case 'dog':
      return new DogCollision(scene, entity as DogBlockEntity);
    case 'door':
      return new DoorCollision(scene, entity as DoorBlockEntity);
    case 'firebox':
      return new FireboxCollision(scene, entity as FireboxBlockEntity);
    case 'hat':
      return new HatCollision(scene, entity as HatBlockEntity);
    case 'hazard':
      return new HazardCollision(scene, entity as HazardBlockEntity);
    case 'kappa':
      return new KappaCollision(scene, entity as KappaBlockEntity);
    case 'kettle':
      return new KettleCollision(scene, entity as KettleBlockEntity);
    case 'lock':
      return new LockCollision(scene, entity as LockBlockEntity);
    case 'miniFugu':
      return new MiniFuguCollision(scene, entity as MiniFuguBlockEntity);
    case 'panther':
      return new PantherCollision(scene, entity as PantherBlockEntity);
    case 'pipe':
      return new PipeCollision(scene, entity as PipeBlockEntity);
    case 'rocket':
      return new RocketCollision(scene, entity);
    case 'siren':
      return new SirenCollision(scene, entity as SirenBlockEntity);
    case 'skull':
      return new SkullCollision(scene, entity as SkullBlockEntity);
    case 'slime':
      return new SlimeCollision(scene, entity as SlimeBlockEntity);
    case 'spider':
      return new SpiderCollision(scene, entity as SpiderBlockEntity);
    case 'statue':
      return new StatueCollision(scene, entity as StatueBlockEntity);
    case 'fugu':
      return new FuguCollision(scene, entity as FuguBlockEntity);
    case 'thrower':
      return new ThrowerCollision(scene, entity as ThrowerBlockEntity);
    case 'virus':
      return new VirusCollision(scene, entity as VirusBlockEntity);
    case 'wall':
      return new WallCollision(scene, entity as WallBlockEntity);
    case 'zombie':
      return new ZombieCollision(scene, entity as ZombieBlockEntity);
    case 'ice':
      return new IceCollision(scene, entity as IceBlockEntity);
    case 'thickIce':
      return new ThickIceCollision(scene, entity as ThickIceBlockEntity);
    case 'fullIce':
      return new FullIceCollision(scene, entity as FullIceBlockEntity);
    case 'halfIce':
      return new HalfIceCollision(scene, entity as HalfIceBlockEntity);
    case 'worm':
      return new WormCollision(scene, entity as WormBlockEntity);
    case 'cocoon':
      return new CocoonCollision(scene, entity as CocoonBlockEntity);
    case 'butterfly':
      return new ButterflyCollision(scene, entity as ButterflyBlockEntity);
    case 'curtain':
      return new CurtainCollision(scene, entity as CurtainBlockEntity);
    case 'shell':
      return new ShellCollision(scene, entity as ShellBlockEntity);
    case 'pond':
      return new PondCollision(scene, entity as PondBlockEntity);
    case 'candyBag':
      return new CandyBagCollision(scene, entity as CandyBagBlockEntity);
    case 'candy':
      return new CandyCollision(scene, entity as CandyBlockEntity);
    case 'soda':
      return new SodaCollision(scene, entity as SodaBlockEntity);
    case 'bubbles':
      return new BubblesCollision(scene, entity as BubblesBlockEntity);
    case 'alarm':
      return new AlarmCollision(scene, entity as AlarmBlockEntity);
    case 'chocolateEgg':
      return new ChocolateEggCollision(
        scene,
        entity as ChocolateEggBlockEntity,
      );
    case 'nest':
      return new NestCollision(scene, entity as NestBlockEntity);
    case 'mushroom':
      return new MushroomCollision(scene, entity as MushroomBlockEntity);
    case 'parcels':
      return new ParcelsCollision(scene, entity as ParcelsBlockEntity);
    case 'fossil':
      return new FossilCollision(scene, entity as FossilBlockEntity);
    case 'corn':
      return new CornCollision(scene, entity as CornBlockEntity);
    case 'popcorn':
      return new PopcornCollision(scene, entity as PopcornBlockEntity);
    case 'tunaCan':
      return new TunaCanCollision(scene, entity as TunaCanBlockEntity);
    case 'tunaFish':
      return new TunaFishCollision(scene, entity as TunaFishBlockEntity);
    case 'rainbowBubble':
      return new RainbowBubbleCollision(
        scene,
        entity as RainbowBubbleBlockEntity,
      );
    case 'firecrackerBox':
      return new FirecrackerBoxCollision(
        scene,
        entity as FirecrackerBoxBlockEntity,
      );
    case 'cooler':
      return new CoolerCollision(scene, entity as CoolerBlockEntity);
    case 'tv':
      return new TvCollision(scene, entity as TvBlockEntity);
    case 'shieldBubble':
      return new ShieldBubbleCollision(
        scene,
        entity as ShieldBubbleBlockEntity,
      );
    case 'bathtub':
      return new BathtubCollision(scene, entity as BathtubBlockEntity);
    case 'sharpener':
      return new SharpenerBlockCollision(scene, entity as SharpenerBlockEntity);
    case 'barrel':
      return new BarrelBlockCollision(scene, entity as BarrelBlockEntity);
    case 'rainbowSoap':
      return new RainbowSoapBlockCollision(
        scene,
        entity as RainbowSoapBlockEntity,
      );
    case 'bigEgg':
      return new BigEggBlockCollision(scene, entity as BigEggBlockEntity);
    case 'piggyBank':
      return new PiggyBankBlockCollision(scene, entity as PiggyBankBlockEntity);
    case 'balloonBox':
      return new BalloonBoxBlockCollision(
        scene,
        entity as BalloonBoxBlockEntity,
      );
    case 'octopus':
      return new OctopusBlockCollision(scene, entity as OctopusBlockEntity);
    case 'flowerFidget':
      return new FlowerFidgetBlockCollision(
        scene,
        entity as FlowerFidgetBlockEntity,
      );
    case 'grass':
      return new GrassBlockCollision(scene, entity as GrassBlockEntity);
    case 'magicBunnies':
      return new MagicBunniesBlockCollision(
        scene,
        entity as MagicBunniesBlockEntity,
      );
    case 'laserBox':
      return new LaserBoxBlockCollision(scene, entity as LaserBoxBlockEntity);
    default:
      return undefined;
  }
}
